import React from "react";
import {connect} from "react-redux";
import {Button, Col, Form, Input, message, Modal, Row} from "antd";
import {generateContentWriterPersona} from "../../actions/content_writer";
import {displayErrors} from "../../libs/utils";

class PersonaGeneratorModal extends React.Component {
    state = {
        loading: false,
        website_description: ''
    }

    closeModal(updateData = false, data = null) {
        if(this.state.loading) {
            message.warning('Please wait while generating persona...');
            return;
        }

        if(updateData) {
            this.props.updateData(data);
        }

        this.setState({
            loading: false,
            website_description: ''
        })

        this.props.close();
    }

    generate() {
        if(this.state.website_description.trim() === '') {
            return message.error('Please enter a website description!');
        }

        if(this.state.website_description.trim().split(' ').length < 10) {
            return message.error('The website description should have at least 10 words.');
        }

        this.setState({ loading: true });

        this.props.generateContentWriterPersona({website_description: this.state.website_description}, (res) => {
            message.success('Persona generated successfully!');
            this.setState({ loading: false }, () => {
                this.closeModal(true, res.data);
            });

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        })
    }

    render() {
        return <Modal
            centered
            title='Generate Persona'
            open={this.props.showModal}
            destroyOnClose={true}
            footer={<Row justify='space-between'>
                <Col>
                    <Button onClick={() => this.closeModal()} disabled={this.state.loading}>Close</Button>
                </Col>
                <Col>
                    <Button type='primary' onClick={() => this.generate()} disabled={this.state.loading} loading={this.state.loading}>{this.state.loading ? 'Generating...' : 'Generate'}</Button>
                </Col>
            </Row>}
            onCancel={() => this.closeModal()}>
            <Form layout='vertical'>
                <Form.Item label='Website description' extra={<small><em>Briefly describe your website in a few sentences. The more details you provide,
                    the better the persona generator can tailor the results. <b><u>Enter minimum of 10 words!</u></b></em></small>}>
                    <Input onChange={(e) => this.setState({ website_description: e.target.value })} />
                </Form.Item>
            </Form>
        </Modal>;
    }
}

export default connect(null, { generateContentWriterPersona })(PersonaGeneratorModal);